import { createRouter, createWebHistory } from 'vue-router';
import AOS from "aos";
import 'aos/dist/aos.css';
import VehiculesView from '@/frontoffice/pages/VehiculesView.vue';
import VideoView from '@/frontoffice/pages/VideoView.vue';
import VideoDetailsView from '@/frontoffice/pages/VideoDetailsView.vue';
import AnnuaireAgenceView from '@/frontoffice/pages/AnnuaireAgenceView.vue';
import SejourMedicalView from '@/frontoffice/pages/SejourMedicalView.vue';
import MedicalSejourDetails from '@/frontoffice/pages/MedicalSejourDetails.vue';
import SejourMedicalDetailsView from '@/frontoffice/pages/SejourMedicalDetailsView.vue';
const FrontLayout = () => import('../frontoffice/layout/FrontLayout.vue');
const HomeView = () => import('../frontoffice/pages/HomeView.vue');
const HotelsView = () => import('../frontoffice/pages/HotelsView.vue');
const DetailsHotelsView = () => import('../frontoffice/pages/DetailsHotelsView.vue');
const HotelVideoView = () => import('../frontoffice/pages/HotelVideoView.vue');
const DetailsRestaurantsView = () => import('../frontoffice/pages/DetailsRestaurantsView.vue');
const DetailsEventsView = () => import('../frontoffice/pages/DetailsEventsView.vue');
const DetailsMusseView = () => import('../frontoffice/pages/DetailsMusseView.vue');
const RestaurantsView = () => import('../frontoffice/pages/RestaurantsView.vue');
const EventsView = () => import('../frontoffice/pages/EventsView.vue');
const MusseView = () => import('../frontoffice/pages/MusseView.vue');
const WeekendView = () => import('../frontoffice/pages/WeekendView.vue');
const ActivityView = () => import('../frontoffice/pages/ActivityView.vue');
const ActivityDetailsView = () => import('../frontoffice/pages/ActivityDetailsView.vue');
const VolsFindView = () => import('../frontoffice/pages/VolsFindView.vue');
const MaisonView = () => import('../frontoffice/pages/MaisonView.vue');
const MaisonDetailsView = () => import('../frontoffice/pages/MaisonDetailsView.vue');
const AproposView = () => import('../frontoffice/pages/AproposView.vue');
const TermesView = () => import('../frontoffice/pages/TermesView.vue');
const MissionView = () => import('../frontoffice/pages/MissionView.vue');
const ContactView = () => import('../frontoffice/pages/ContactView.vue');
const AnnuaireHotelView = () => import('../frontoffice/pages/AnnuaireHotelView.vue');
const AnnuaireRestaurantView = () => import('../frontoffice/pages/AnnuaireRestaurantView.vue');
const ConfirmationEventView = () => import('../frontoffice/pages/ConfirmationEventView.vue');
const ReservationEventView = () => import('../frontoffice/pages/ReservationEventView.vue');
const ReservationHotelView = () => import('../frontoffice/pages/ReservationHotelView.vue');
const ReservationRestaurantView = () => import('../frontoffice/pages/ReservationRestaurantView.vue');
const AgilView = () => import('../frontoffice/pages/AgilView.vue');
const GatView = () => import('../frontoffice/pages/GatView.vue');
const ComposeCircuitView = () => import('../frontoffice/pages/ComposeCircuitView.vue');
const CircuitReservationView = () => import('../frontoffice/pages/CircuitReservationView.vue');
const SearchPageView = () => import('../frontoffice/pages/SearchPageView.vue');
const ResetPasswordView = () => import('../frontoffice/pages/ResetPasswordView.vue');
const HotelsFindView = () => import('../frontoffice/pages/HotelsFindView.vue');
const WeekendFindView = () => import('../frontoffice/pages/WeekendFindView.vue');
const HotelsFindDestinationView = () => import('../frontoffice/pages/HotelsFindDestinationView.vue');
const ActivityFindView = () => import('../frontoffice/pages/ActivityFindView.vue');
const HotelsFindCityView = () => import('../frontoffice/pages/HotelsFindCityView.vue');
const RestaurantFindCityView = () => import('../frontoffice/pages/RestaurantFindCityView.vue');
const RestaurantFindStateView = () => import('../frontoffice/pages/RestaurantFindStateView.vue');

const RestaurantFindView = () => import('../frontoffice/pages/RestaurantFindView.vue');
const RestaurantFindRes = () => import('../frontoffice/pages/RestaurantFindRes.vue');
const EventFindView = () => import('../frontoffice/pages/EventFindView.vue');
const HotelsFindStateView = () => import('../frontoffice/pages/HotelsFindStateView.vue');

const EventsFindView = () => import('../frontoffice/pages/EventsFindView.vue');
const TelecomView = () => import('../frontoffice/pages/TelecomView.vue');
const SecourView = () => import('../frontoffice/pages/SecourView.vue');
const MonumentView = () => import('../frontoffice/pages/MonumentView.vue');
const FestivalView = () => import('../frontoffice/pages/FestivalView.vue');
const MonumentDetailsView = () => import('../frontoffice/pages/MonumentDetailsView.vue');
const FestivalDetailsView = () => import('../frontoffice/pages/FestivalDetailsView.vue');
const StatesView = () => import('../frontoffice/pages/StatesView.vue');
const DestinationView = () => import('../frontoffice/pages/DestinationView.vue');
const CityView = () => import('../frontoffice/pages/CityView.vue');
const MaisonFindView = () => import('../frontoffice/pages/MaisonFindView.vue');
const UserView = () => import('../frontoffice/pages/UserView.vue');
const ConfirmationCircuitView = () => import('../frontoffice/pages/ConfirmationCircuitView.vue');
const ActivityFindStateView = () => import('../frontoffice/pages/ActivityFindStateView.vue');
const MaisonFindStateView = () => import('../frontoffice/pages/MaisonFindStateView.vue');
const EventFindStateView = () => import('../frontoffice/pages/EventFindStateView.vue');
const IteneraireView = () => import('../frontoffice/pages/IteneraireView.vue');
const PayementView = () => import('../PayementView.vue');
const PayementSuccessView = () => import('../PayementSuccessView.vue');
const PayementEchecView = () => import('../PayementEchecView.vue');
const CGVView = () => import('../frontoffice/pages/CGVView.vue');
const GuideView = () => import('../frontoffice/pages/GuideView.vue');
const CircuitsView = () => import('../frontoffice/pages/CircuitsView.vue');
const CircuitsDetailsView = () => import('../frontoffice/pages/CircuitsDetailsView.vue');
const AllGuides = () => import('../frontoffice/pages/AllGuidesView.vue');
const GuideDetailsView = () => import('../frontoffice/pages/GuideDetailsView.vue');
const AgenceView = () => import('../frontoffice/pages/AgenceView.vue');
const AgenceDetails = () => import('../frontoffice/pages/AgenceDetails.vue');
const PageNotFound = () => import('../frontoffice/pages/PageNotFound.vue');
const ArtisanatView = () => import('../frontoffice/pages/ArtisanatsView.vue');
const DetailsArtisanatsView = () => import('../frontoffice/pages/DetailsArtisanatsView.vue');
const routes = [
  {
    path: '/payment',
    component: PayementView,
    props: (route) => ({ query: route.query.order })

  },
  {
    path: '/payment/success',
    component: PayementSuccessView,
    props: (route) => ({ query: route.query.order })
  },
  {
    path: '/payment/echec',
    component: PayementEchecView,
    props: (route) => ({ query: route.query.order })
  },
  {
    path: '/:lang(en|fr|ar|ru|zh|ja|ko)?',
    component: FrontLayout,
    children: [
      {
        path: '',
        component: HomeView,
        name: 'HomeView',
        meta: {
          title: 'Page d\'accueil - GabongoTravel',
          metaTitle: 'Page d\'accueil',
          metaDescription: 'Découvrez les meilleures offres et services de tourisme en Gabon.'
        },
      },
      {
        path: 'cgv',
        component: CGVView,
      },
      {
        path: 'artisanats',
        component: ArtisanatView,
      },
      {
        path: 'sejour',
        component: SejourMedicalView,
      },
      {
        path: 'sejour/:slug',
        component: MedicalSejourDetails,
        props: true,
      },
      {
        path: 'sejour/:slug/details/:id',
        component: SejourMedicalDetailsView,
        props: true,
      },
      {
        path: 'artisanats/:slug',
        component: DetailsArtisanatsView,
        props: true,
      },
      {
        path: 'allguides',
        component: AllGuides,
      },
      {
        path: 'allguides/:id',
        component: GuideDetailsView,
        props: true,
      },
      {
        path: 'circuits',
        component: CircuitsView,
      },
      {
        path: 'circuits/:slug',
        component: CircuitsDetailsView,
        props: true,
      },
      {
        path: 'user',
        component: UserView,
        meta: { requiresAuth: true },
      },
      {
        path: 'guide',
        component: GuideView,
        meta: { requiresAuth: true },
      },
      {
        path: 'search',
        component: SearchPageView,
        name: 'search',
        props: (route) => ({ query: route.query.q })
      },
      {
        path: 'states/:slug',
        component: StatesView,
        name: 'StatesView',
        props: true,
      },
      {
        path: 'iteneraire/:lat1/:lng1',
        component: IteneraireView,
        name: 'IteneraireView',
        props: true,
      },
      {
        path: 'city/:slug',
        component: CityView,
        name: 'CityView',
        props: true,
      },
      {
        path: 'destination/:slug',
        component: DestinationView,
        name: 'DestinationView',
        props: true,
      },
      {
        path: 'apropos',
        component: AproposView,
        meta: {
          title: 'À propos de GabongoTravel',
          metaTitle: 'À propos de notre service',
          metaDescription: 'Découvrez l\'histoire et la mission de GabongoTravel, votre guide de voyage en Gabon.'
        }
      },
      {
        path: 'agences',
        component: AgenceView,
        meta: {
          title: 'Les agences de GabongoTravel',
          metaTitle: 'Les agences de notre service',
          metaDescription: 'Découvrez l\'histoire et la mission de GabongoTravel, votre guide de voyage en Gabon.'
        }
      },
      {
        path: 'agences/annuaire',
        component: AnnuaireAgenceView,
        meta: {
          title: 'Les agences de GabongoTravel',
          metaTitle: 'Les agences de notre service',
          metaDescription: 'Découvrez l\'histoire et la mission de GabongoTravel, votre guide de voyage en Gabon.'
        }
      },
      {
        path: 'agences/:slug',
        component: AgenceDetails,
        meta: {
          title: 'Les agences details de GabongoTravel',
          metaTitle: 'Les agences details de notre service',
          metaDescription: 'Découvrez l\'histoire et la mission de GabongoTravel, votre guide de voyage en Gabon.'
        }
      },
      {
        path: 'monument',
        component: MonumentView,
        meta: {
          title: 'Monuments Historiques - GabongoTravel',
          metaTitle: 'Découvrez les Monuments en Gabon',
          metaDescription: 'Explorez les monuments historiques incontournables en Gabon et plongez dans l\'histoire du pays.'
        }
      },
      {
        path: 'monument/:id', component: MonumentDetailsView,
        name: 'MonumentDetailsView',
        props: true,
      },
      {
        path: 'festival/:id', component: FestivalDetailsView,
        name: 'FestivalDetailsView',
        props: true,
      },
      {
        path: 'festival',
        component: FestivalView,
        meta: {
          title: 'Festivals en Gabon - GabongoTravel',
          metaTitle: 'Découvrez les Festivals en Gabon',
          metaDescription: 'Explorez les festivals incontournables en Gabon, une destination riche en événements culturels et festifs.'
        }
      }
      ,
      {
        path: 'secour',
        component: SecourView,
        meta: {
          title: 'Secours en Gabon - GabongoTravel',
          metaTitle: 'Services de Secours en Gabon',
          metaDescription: 'Découvrez les services de secours disponibles en Gabon pour assurer votre sécurité et bien-être.'
        }
      }
      ,
      { path: 'confirmation', component: ConfirmationEventView },
      { path: 'circuits/confirmation', component: ConfirmationCircuitView },
      {
        path: 'termes',
        component: TermesView,
        meta: {
          title: 'Termes et Conditions - GabongoTravel',
          metaTitle: 'Termes et Conditions',
          metaDescription: 'Consultez les termes et conditions d\'utilisation de GabongoTravel pour connaître les règles et politiques applicables.'
        }
      }
      ,
      {
        path: 'mission',
        component: MissionView,
        meta: {
          title: 'Notre Mission - GabongoTravel',
          metaTitle: 'Mission de GabongoTravel',
          metaDescription: 'Découvrez la mission de GabongoTravel et notre engagement à offrir les meilleures expériences de voyage en Gabon.'
        }
      }
      ,
      {
        path: 'hotels', component: HotelsView,
        meta: {
          title: 'Nos Hôtels - GabongoTravel',
          metaTitle: 'Hôtels en Gabon',
          metaDescription: 'Découvrez une sélection d\'hôtels de qualité en Gabon.'
        },
      },
      {
        path: 'hotels/annuaire',
        component: AnnuaireHotelView,
        meta: {
          title: 'Annuaire des Hôtels - GabongoTravel',
          metaTitle: 'Annuaire des Hôtels en Gabon',
          metaDescription: 'Explorez l\'annuaire des hôtels en Gabon pour trouver des options de qualité et réserver facilement votre séjour.'
        }
      }
      ,
      {
        path: 'restaurants',
        component: RestaurantsView,
        meta: {
          title: 'Restaurants - GabongoTravel',
          metaTitle: 'Restaurants en Gabon',
          metaDescription: 'Découvrez une sélection de restaurants en Gabon offrant une expérience culinaire inoubliable.'
        }
      },
      {
        path: 'hotels/find/:destination/:date/:endDate/:adults/:rooms/:childs/',
        component: HotelsFindView,
        name: 'HotelsFindView',
        props: true
      },
      {
        path: 'hotels/findHotel/:destination',
        component: HotelsFindDestinationView,
        name: 'HotelsFindDestinationView',
        props: true
      },
      {
        path: 'hotels/findHotel/state/:state',
        component: HotelsFindStateView,
        name: 'HotelsFindStateView',
        props: true
      },
      {
        path: 'hotels/findCity/:destination',
        component: HotelsFindCityView,
        name: 'HotelsFindCityView',
        props: true
      },
      {
        path: 'restaurants/findCity/:destination',
        component: RestaurantFindCityView,
        name: 'RestaurantFindCityView',
        props: true
      },
      {
        path: 'restaurants/findState/:state',
        component: RestaurantFindStateView,
        name: 'RestaurantFindStateView',
        props: true
      },
      {
        path: 'weekend/findWeekend/:destination',
        component: WeekendFindView,
        name: 'WeekendFindView',
        props: true
      },
      {
        path: 'activity/findActivity/:destination',
        component: ActivityFindView,
        name: 'ActivityFindView',
        props: true
      },
      {
        path: 'activity/findActivity/state/:state',
        component: ActivityFindStateView,
        name: 'ActivityFindStateView',
        props: true
      },
      {
        path: 'maison/findMaison/:destination',
        component: MaisonFindView,
        name: 'MaisonFindView',
        props: true
      },
      {
        path: 'maison/findMaison/state/:state',
        component: MaisonFindStateView,
        name: 'MaisonFindStateView',
        props: true
      },
      {
        path: 'restaurants/find/:destination/:date/:number',
        component: RestaurantFindView,
        name: 'RestaurantFindView',
        props: true
      },
      {
        path: 'restaurants/findRes/:destination',
        component: RestaurantFindRes,
        name: 'RestaurantFindRes',
        props: true
      },
      {
        path: 'events/find/:destination',
        component: EventsFindView,
        name: 'EventsFindView',
        props: true
      },
      {
        path: 'events/findEvent/:destination',
        component: EventFindView,
        name: 'EventFindView',
        props: true
      },
      {
        path: 'events/findEvent/state/:destination',
        component: EventFindStateView,
        name: 'EventFindStateView',
        props: true
      },
      { path: 'restaurants/reservation', component: ReservationRestaurantView },
      {
        path: 'restaurants/annuaire',
        component: AnnuaireRestaurantView,
        meta: {
          title: 'Annuaire des Restaurants - GabongoTravel',
          metaTitle: 'Annuaire des Restaurants en Gabon',
          metaDescription: 'Explorez l\'annuaire complet des restaurants en Gabon pour trouver les meilleures options culinaires dans le pays.'
        }
      }
      ,
      {
        path: 'events',
        component: EventsView,
        meta: {
          title: 'Événements - GabongoTravel',
          metaTitle: 'Découvrez les Événements en Gabon',
          metaDescription: 'Explorez les événements à venir en Gabon et planifiez votre prochaine aventure culturelle.'
        }
      }
      ,
      {
        path: 'events/reservation/:id', component: ReservationEventView,
        name: 'ReservationEventView',
        props: true,
      },
      { path: 'hotels/reservation', component: ReservationHotelView },
      {
        path: 'maison',
        component: MaisonView,
        meta: {
          title: 'Maison - GabongoTravel',
          metaTitle: 'Découvrez nos Maisons en Gabon',
          metaDescription: 'Explorez une sélection de maisons uniques à louer ou acheter en Gabon.'
        }
      }
      ,
      { path: 'vols/find/:departAirport/:arriveAirport', component: VolsFindView },
      {
        path: 'maison/:id',
        component: MaisonDetailsView,
        name: 'MaisonDetailsView',
        props: true,
      },
      {
        path: 'musses',
        component: MusseView,
        meta: {
          title: 'Musées - GabongoTravel',
          metaTitle: 'Explorez les Musées en Gabon',
          metaDescription: 'Découvrez les musées fascinants à visiter en Gabon et explorez le riche patrimoine culturel du pays.'
        }
      }
      ,
      {
        path: 'weekend',
        component: WeekendView,
        meta: {
          title: 'Weekends - GabongoTravel',
          metaTitle: 'Les Meilleurs Weekends en Gabon',
          metaDescription: 'Découvrez des idées de week-ends inoubliables à travers la Gabon.'
        }
      }
      ,
      {
        path: 'contact',
        component: ContactView,
        meta: {
          title: 'Contactez-nous - GabongoTravel',
          metaTitle: 'Contactez-nous pour plus d\'informations',
          metaDescription: 'Contactez l\'équipe de GabongoTravel pour toute question ou demande d\'information.'
        }
      }
      ,
      {
        path: 'activity',
        component: ActivityView,
        meta: {
          title: 'Activités de loisirs - GabongoTravel',
          metaTitle: 'Découvrez les meilleures activités en Gabon',
          metaDescription: 'Explorez une variété d\'activités passionnantes à faire en Gabon pour tous les goûts et tous les âges.'
        }
      }
      ,
      {
        path: 'activity/:id',
        component: ActivityDetailsView,
        name: 'ActivityDetailsView',
        props: true,
      },
      {
        path: 'vehicules',
        component: VehiculesView,
        meta: {
          title: 'Voitures de location - GabongoTravel',
          metaTitle: 'Louez une voiture en Gabon',
          metaDescription: 'Trouvez la voiture idéale pour votre voyage en Gabon parmi une large sélection de véhicules disponibles.'
        }
      }
      ,
      {
        path: 'circuits/compose',
        component: ComposeCircuitView,
        meta: {
          title: 'Créer un circuit - GabongoTravel',
          metaTitle: 'Composez votre circuit en Gabon',
          metaDescription: 'Personnalisez votre propre circuit et découvrez les meilleures destinations en Gabon selon vos préférences.'
        }
      }
      ,
      { path: 'circuits/reservation', component: CircuitReservationView },
      {
        path: 'agil',
        component: AgilView,
        meta: {
          title: 'Agil - GabongoTravel',
          metaTitle: 'Découvrez Agil en Gabon',
          metaDescription: 'Explorez l\'agilité et les services offerts par Agil en Gabon pour une expérience de voyage unique.'
        }
      }
      ,
      {
        path: 'tt',
        component: TelecomView,
        meta: {
          title: 'Telecom - GabongoTravel',
          metaTitle: 'Explorez les services télécoms en Gabon',
          metaDescription: 'Découvrez les meilleures options de télécommunications et services liés à la connectivité en Gabon.'
        }
      }
      ,
      {
        path: 'gat',
        component: GatView,
        meta: {
          title: 'Gat - GabongoTravel',
          metaTitle: 'Explorez les destinations de Gat en Gabon',
          metaDescription: 'Découvrez les attractions et activités incontournables à Gat, une destination populaire en Gabon.'
        }
      }
      ,
      {
        path: 'reset-password/:token/:email',
        component: ResetPasswordView,
        name: 'ResetPasswordView',
        props: true,
      },
      {
        path: 'videos',
        component: VideoView,
      },
      {
        path: 'videos/:slug',
        component: VideoDetailsView,
      },
      {
        path: 'hotels/:id',
        component: DetailsHotelsView,
        name: 'DetailsHotelsView',
        props: true,
      },
      {
        path: 'hotels/video/:id',
        component: HotelVideoView,
        name: 'HotelVideoView',
        props: true,
      },
      {
        path: 'restaurants/:id',
        component: DetailsRestaurantsView,
        name: 'DetailsRestaurantsView',
        props: true,
      },
      {
        path: 'events/:id',
        component: DetailsEventsView,
        name: 'DetailsEventsView',
        props: true,
      },
      {
        path: 'musses/:id',
        component: DetailsMusseView,
        name: 'DetailsMusseView',
        props: true,
      },
      {
        path: "/:pathMatch(.*)*",
        name: "PageNotFound",
        component: PageNotFound,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  // eslint-disable-next-line
  scrollBehavior(to, from, savedPosition) {
    // Always scroll to the top
    return { top: 0 };
  },
});
router.beforeEach((to, from, next) => {
  AOS.init();
  const lang = to.params.lang || 'fr'; // Default to French
  if (!['en', 'fr', 'ar', 'ru', 'ko', 'zh', 'ja'].includes(lang)) {
    return next('/fr'); // Redirect invalid languages to default
  }
  const isAuthenticated = localStorage.getItem('token');

  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'HomeView' });
  }
  next();
});
export default router;